import React, { useEffect, useState } from 'react';
import { parseProps, componentIdGenerator } from './@uteis';
import BRSelect from '../../assets/dsgov/js/components/select';
import '../../assets/dsgov/css/components/select.css';
import './Select.css';

import Button from './Button';
import Input from './Input';
import List from './List';

const Select = (_props) => {
  const [componentId] = useState(`select${componentIdGenerator()}`);
  const [selected] = useState('');
  const [component, setComponent] = useState(null);

  const props = parseProps(_props);

  useEffect(() => {
    const componentDom = window.document.querySelector(`.${componentId}`);
    if (props.multiple) componentDom.setAttribute('multiple', '');
    setComponent(new BRSelect('br-select', componentDom));
  }, []);

  useEffect(() => {
    if (!component) return;
    component.optionsList = component._setOptionsList();
    component._setBehavior();
    const index = component.optionsList.findIndex((o) => o.value === props.value);
    const options = component.component.querySelectorAll('.br-list .item');
    component._removeAll();
    if (options[index]) {
      component._setSelected(index, options[index]);
    }
  });

  const onBlurHandler = () => {
    if (props.onChange) {
      let value = component.selected;
      if (Array.isArray(value) && value.length === 0) {
        value = '';
      }
      props.onChange(value);
    }
  };

  let classes = `br-select ${componentId} `;
  if (props.classes) classes += props.classes;

  const attr = {
    small: props.small,
  };

  const label = props.label ? props.label : null;
  const placeholder = props.placeholder ? props.placeholder : 'Selecione o item';

  const showButton = () => (
    <Button
      classes="circle small"
      tabIndex="-1"
      data-trigger
      disabled={props.disabled || false}
    >
      <span className="sr-only">Exibir lista</span>
      <i className="fas fa-angle-down" />
    </Button>
  );

  return (
    <div
      className={classes}
      {...attr}
      onBlur={onBlurHandler}

    >
      <Input
        inline={props.inline || false}
        labelWidth={props.labelWidth || null}
        width={props.width || null}
        value={selected}
        label={label}
        placeholder={placeholder}
        onChange={() => {}}
        disabled={props.disabled || false}
        button={showButton()}
        size={props.size || null}
      />
      <List
        style={{
          left: `${props.labelWidth}px`,
          width: `calc(100% - ${props.labelWidth || 0}px)`,
        }}
      >
        {props.children}
      </List>
    </div>
  );
};

export default Select;
